module.exports = __webpack_public_path__ + "img/4.146a16b8.svg";